/* eslint-disable sonarjs/no-duplicate-string */
import { defineMessages } from "react-intl";
import { useMessages } from "2g-hooks/intl";

export const MESSAGES = defineMessages({
  vyluka: {
    id: "b2b.renderers.aktivni.vyluka",
    defaultMessage: "Výluka"
  },
  ano: {
    id: "b2b.renderers.ano-ne.ano",
    defaultMessage: "YES"
  },
  ne: {
    id: "b2b.renderers.ano-ne.ne",
    defaultMessage: "NO"
  },
  poznamkaModi: {
    id: "b2b.renderers.poznamka-modi.label",
    defaultMessage: "Modified note"
  },
  poznamkaModiZakaznik: {
    id: "b2b.renderers.poznamka-modi.zakaznik",
    defaultMessage: "Customer"
  },
  poznamkaModiSpravce: {
    id: "b2b.renderers.poznamka-modi.spravce",
    defaultMessage: "Administrator"
  },
  poznamkaModiStrojvedouci: {
    id: "b2b.renderers.poznamka-modi.strojvedouci",
    defaultMessage: "Train driver"
  }
});

export default () => useMessages(MESSAGES);
